<template>
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.0833 19H7.91667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 30.0833L7.91667 19L19 7.91666" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "ArrowLeftIcon"
}
</script>

<style scoped>

</style>
